import { render } from "./buttonPage.vue?vue&type=template&id=bc73173c&scoped=true"
import script from "./buttonPage.vue?vue&type=script&lang=js"
export * from "./buttonPage.vue?vue&type=script&lang=js"

import "./buttonPage.vue?vue&type=style&index=0&id=bc73173c&lang=scss&scoped=true"
import "./buttonPage.vue?vue&type=style&index=1&id=bc73173c&lang=css"
import "./buttonPage.vue?vue&type=style&index=2&id=bc73173c&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc73173c"]])

export default __exports__